var map = {
	"./bekanntmachung.png": 12657,
	"./bekanntmachung_bubble.png": 40993,
	"./beteiligung_familie.png": 5652,
	"./beteiligung_familie_bubble.png": 83207,
	"./beteiligung_krise.png": 55341,
	"./beteiligung_krise_bubble.png": 46515,
	"./beteiligung_politik.png": 17336,
	"./beteiligung_politik_bubble.png": 43588,
	"./beteiligung_schule.png": 54173,
	"./beteiligung_schule_bubble.png": 57809,
	"./informationsfreiheit.png": 66699,
	"./informationsfreiheit_bubble.png": 36195,
	"./religionsfreiheit.png": 39345,
	"./religionsfreiheit_bubble.png": 30815,
	"./sexuelle_selbstbestimmung.png": 55683,
	"./sexuelle_selbstbestimmung_bubble.png": 11917,
	"./umsetzung.png": 34678,
	"./umsetzung_bubble.png": 89440
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45483;